import { createFileRoute } from "@tanstack/react-router";
import { UserEditPage } from "../../../components/users/UserEditPage";
import { requireModuleAndPermission, MODULE_WORKSPACE } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/workspace/users/$userId/edit")({
  beforeLoad: requireModuleAndPermission(MODULE_WORKSPACE, "user:update"),
  component: UserEditRoute,
});

function UserEditRoute() {
  const { userId } = Route.useParams();
  return <UserEditPage userId={userId} />;
}
